import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from '../BusinessDashboard.module.scss'
import { ReactComponent as MoneyCheckCircle } from '../../../../../assets/images/common/icons/money-check-dollar-circle.svg'
import PropTypes from 'prop-types'
import ButtonLink from '../../../../common/buttons/ButtonLink'

const Placeholder = ({ communityHasEnrollments, hasDataWithoutRevenue, isRevenue }) => {
  const { t } = useTranslation()

  const title = communityHasEnrollments
    ? (isRevenue
      ? (hasDataWithoutRevenue
        ? t('dashboard.business.financialPerformance.placeholder.revenueNotTrackedTitle')
        : t('dashboard.business.financialPerformance.placeholder.noRevenueFoundTitle') )
      : t('dashboard.business.financialPerformance.placeholder.noRegistrationsFoundTitle'))
    : t('dashboard.business.financialPerformance.placeholder.noRegistrationsOrRevenueTitle')

  const body = communityHasEnrollments
    ? (hasDataWithoutRevenue
      ? t('dashboard.business.financialPerformance.placeholder.revenueNotTrackedBody')
      : t('dashboard.business.financialPerformance.placeholder.noActivityBody'))
    : t('dashboard.business.financialPerformance.placeholder.noEnrollmentsBody')

  const buttonText = hasDataWithoutRevenue
    ? t('dashboard.business.financialPerformance.placeholder.createPackageButton')
    : t('dashboard.business.financialPerformance.placeholder.viewProgramsButton')
  const buttonNavigateTo = hasDataWithoutRevenue ? '/community-settings/pricing' : '/programs'

  return (
    <div className={classNames('d-flex flex-column justify-content-center align-items-center text-center', classes.placeholder)}>
      <MoneyCheckCircle className={classes.icon} />
      <h3 className={classNames('my-3', classes.noActivitiesTitle)}>{title}</h3>
      <p className={classes.noActivitiesText}>{body}</p>
      {(!communityHasEnrollments || hasDataWithoutRevenue) && (
        <ButtonLink
          navigateTo={buttonNavigateTo}
          noTopMargin
          className={classes.placeholderButton}
        >
          {buttonText}
        </ButtonLink>
      )}
      {!communityHasEnrollments && (
        <a
          className='mt-2'
          href='https://intercom.help/op-36/en/articles/11144105-onboarding-101-create-group-classes'
          target='_blank'
        >
          {t('dashboard.business.financialPerformance.placeholder.learnHowLink')}
        </a>
      )}
    </div>
  )
}

Placeholder.propTypes = {
  communityHasEnrollments: PropTypes.bool,
  isRevenue: PropTypes.bool,
  hasDataWithoutRevenue: PropTypes.bool,
}

export default Placeholder
